import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FF305496" },
};
const HEADER_FONT = {
  name: "Calibri",
  size: 11,
  bold: true,
  color: { argb: "FFFFFFFF" },
};
const BODY_FONT = { name: "Calibri", size: 11, color: { argb: "FF1F2937" } };
const ZEBRA_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFF3F6FB" },
};
const THIN_BORDER = {
  top: { style: "thin", color: { argb: "FFBFBFBF" } },
  left: { style: "thin", color: { argb: "FFBFBFBF" } },
  bottom: { style: "thin", color: { argb: "FFBFBFBF" } },
  right: { style: "thin", color: { argb: "FFBFBFBF" } },
};

const parseDomTable = (table) => {
  const rows = [];
  const merges = [];
  const occupied = {};
  const trList = table.querySelectorAll("tr");
  let headerRowsCount = table.querySelectorAll("thead tr").length;
  if (!headerRowsCount) {
    headerRowsCount = trList.length && trList[0].querySelector("th") ? 1 : 0;
  }

  trList.forEach((tr, rIdx) => {
    const row = [];
    let cIdx = 0;
    Array.from(tr.children).forEach((cell) => {
      while (occupied[`${rIdx}_${cIdx}`]) {
        row.push(null);
        cIdx += 1;
      }
      const colspan = parseInt(cell.getAttribute("colspan"), 10) || 1;
      const rowspan = parseInt(cell.getAttribute("rowspan"), 10) || 1;
      const text = (cell.textContent || "").trim();
      const num = text !== "" && !isNaN(text.replace(",", "."))
        ? Number(text.replace(",", "."))
        : text;
      row.push(num);
      if (colspan > 1 || rowspan > 1) {
        merges.push({
          top: rIdx + 1,
          left: cIdx + 1,
          bottom: rIdx + rowspan,
          right: cIdx + colspan,
        });
        for (let r = 0; r < rowspan; r += 1) {
          for (let c = 0; c < colspan; c += 1) {
            if (r === 0 && c === 0) continue;
            occupied[`${rIdx + r}_${cIdx + c}`] = true;
          }
        }
      }
      cIdx += colspan;
      for (let c = 1; c < colspan; c += 1) row.push(null);
    });
    rows.push(row);
  });

  return { rows, merges, headerRowsCount };
};

export const getExcelFromTable = async (table, fileName) => {
  const { rows, merges, headerRowsCount } = parseDomTable(table);
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("1 страница", {
    views: [{ state: "frozen", ySplit: headerRowsCount }],
  });

  rows.forEach((row) => ws.addRow(row.map((v) => (v == null ? "" : v))));

  merges.forEach(({ top, left, bottom, right }) => {
    ws.mergeCells(top, left, bottom, right);
  });

  const colWidths = [];
  rows.forEach((row) => {
    row.forEach((val, i) => {
      const len = val == null ? 0 : String(val).length;
      colWidths[i] = Math.max(colWidths[i] || 10, Math.min(len + 2, 50));
    });
  });
  colWidths.forEach((w, i) => {
    ws.getColumn(i + 1).width = w;
  });

  ws.eachRow((row, rowNumber) => {
    const isHeader = rowNumber <= headerRowsCount;
    row.height = isHeader ? 26 : 20;
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.border = THIN_BORDER;
      cell.alignment = {
        vertical: "middle",
        horizontal: isHeader ? "center" : "left",
        wrapText: true,
      };
      if (isHeader) {
        cell.fill = HEADER_FILL;
        cell.font = HEADER_FONT;
      } else {
        cell.font = BODY_FONT;
        if ((rowNumber - headerRowsCount) % 2 === 0) cell.fill = ZEBRA_FILL;
        if (typeof cell.value === "number") {
          cell.alignment = { ...cell.alignment, horizontal: "right" };
        }
      }
    });
  });

  const buf = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buf], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `${fileName}.xlsx`
  );
};
